export default __webpack_public_path__ + "static/media/II-2023.561266f1.pdf";